function NameOf<T>(key: keyof T, instance?: T): keyof T {
    return key;
}

export { NameOf };



// WEBPACK FOOTER //
// ./src/utils/NameOf.ts